var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstructionOutlinedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warranty",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 19.8,
    height: 18.556,
    transform: "translate(0 0)",
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2065",
    "data-name": "Groupe 2065",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2064",
    "data-name": "Groupe 2064",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_762",
    "data-name": "Trac\\xE9 762",
    d: "M11.683,12.56,13.8,10.439l6,6-2.121,2.121ZM15.4,7.388a3.5,3.5,0,0,0,3.5-3.5,3.455,3.455,0,0,0-.41-1.6l-2.7,2.7L14.3,3.5,17,.8a3.455,3.455,0,0,0-1.6-.41,3.5,3.5,0,0,0-3.5,3.5,3.41,3.41,0,0,0,.21,1.16L10.26,6.9,8.48,5.118l.71-.71L7.78,3,9.9.878a3,3,0,0,0-4.24,0L2.12,4.418l1.41,1.41H.71L0,6.538l3.54,3.54.71-.71V6.538l1.41,1.41.71-.71,1.78,1.78L.74,16.428l2.12,2.12L14.24,7.178a3.41,3.41,0,0,0,1.16.21",
    fill: "#959FB2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionOutlinedGrey);
export default __webpack_public_path__ + "static/media/ConstructionOutlinedGrey.bbe3ebdfd71f86e58d226d5736dd9dbd.svg";
export { ForwardRef as ReactComponent };